export const OptionsBuilderItemTypes = {
	KeyMeasureFact: 'KeyMeasureFact',
	Dimension: 'Dimension',
	DimensionAttribute: 'DimensionAttribute',
	DatePeriodSelector: 'DatePeriodSelector',
	DateSeries: 'DateSeries',
	CalculatedFact: 'CalculatedFact',
};
